module.exports = __webpack_public_path__ + "img/pattern1 blue copy 143.b8ff4c9a.svg";